<main class="app_template_c__container" id="templateContainer">
  <app-print-header></app-print-header>
  <p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
    <ng-template pTemplate="header">
      <label><strong>Esops de exposición: </strong>
        {{ examen.esops?.length }}</label>
    </ng-template>
    <p-scrollPanel [style]="{ height: '200px' }">
      <p-table [value]="examen.esops">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Código</th>
            <th style="width: 80%; text-align: center;">Concepto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="text-align: center;">{{ item.codigo }}</td>
            <td style="text-align: center;">{{ item.descripcion }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-scrollPanel>
    <p-footer>
      <p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
    </p-footer>
  </p-dialog>
  <!-- ------------------------------------------------inicio de formulario------------------------------------------------ -->

  <form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
    <div class="form-container p-fluid">

      <!-- ------------------------------------------------encabezado------------------------------------------------ -->
      <div class="p-grid p-jc-between" style="margin-bottom: 15px;">
        <div class="" style="display: flex;">
          <span>
            <i (click)="goBack()" class="pi pi-arrow-left"
              style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
          </span>
          <label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
        </div>

        <span class="print_hide-on-print">
          <app-print-button></app-print-button>
        </span>
      </div>
      <!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
      <div class="p-grid">
        <div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
          <app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
          <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
            {{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
          </span>

          <p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
            [minDate]="minDate" class="print_hide-on-print"
            [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
            [disabled]="examen?.modoVista === 'ver'">
          </p-calendar>

          <app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid"></app-invalid-from-message>
        </div>

        <!-- NRO LOTE-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Lote"></app-fiel-title>
          <p class="readOnly">
            {{examen.lote.numeroLote}}
          </p>
        </div>

        <!-- NRO CARPETA-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Carpeta"></app-fiel-title>
          <p class="readOnly">
            {{examen.numeroCarpeta}}
          </p>
        </div>

        <div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
          <label class="color-text" (click)="displayAgentes = true">
            Esops de exposición ({{ examen.esops?.length }})</label>
        </div>
      </div>

      <!-- Seccion Empleador -->
      <div *ngIf="configForm.findSection('Empleador')">
        <div class="p-grid p-mt-2">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Empleador") }}.Datos de la empresa
          </label>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón Social"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIT"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Establecimiento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Dirección de E-mail"></app-fiel-title>
            <p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
          </div>
        </div>
      </div>

      <!-- Seccion Trabajador -->
      <div *ngIf="configForm.findSection('Trabajador')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Trabajador") }}.Datos Del Trabajador
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid p-grid-space">
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
              formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.apellidoNombre.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
								message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
							</app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIL"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.cuil}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
              (onSelect)="calculateAge()" (onBlur)="calculateAge()"
              [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
            </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="DNI"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.numeroDocumento}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Sexo"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.sexo}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Edad"></app-fiel-title>
            <p class="readOnly">
              {{ examen.trabajador.edad }} años
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}" alfanumericoDirective
              formControlName="puestoTrabajador" id="puesto" name="puesto" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.puestoTrabajador.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
              [disabled]="examen?.modoVista === 'ver'">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
              [minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
              (onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
            </p-calendar>
            <app-invalid-from-message
              *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ----------------------------------3.Antecedentes ---------------------------------- -->
      <div *ngIf="configForm.findSection('Antecedentes')">
        <div class="print_dont_break">
          <div class="p-grid p-mt-2">
            <span class="p-title-seccion">
              {{ configForm.findNumberSection("Antecedentes") }}.Antecedentes
            </span>
          </div>
          <p-divider></p-divider>
          <!-- ----------------------------------Antecedentes Enfermedad ---------------------------------- -->
          <div class="p-col-12 p-md-12">
            <div class="p-grid">
              <div class="p-col-12 p-md-4">
                <app-fiel-title label="Antecedentes de enfermedad: " required="true"></app-fiel-title>
              </div>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div *ngIf="configForm.findField('antecedentesEnfermedadSi')" class="p-col-12 p-md-6">
                  <div class="p-field-checkbox ">
                    <p-checkbox (onChange)="clickCheckBox('antecedentesEnfermedadSi', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.antecedentesEnfermedadSi.value && !f.antecedentesEnfermedadNo.value}"
                      formControlName="antecedentesEnfermedadSi" inputId="antecedentesEnfermedadSi" label="Si"
                      name="antecedentesEnfermedadSi" [ngModel]="examen.antecedentesEnfermedad"
                      [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div *ngIf="configForm.findField('antecedentesEnfermedadNo')" class="p-col-12 p-md-6">
                  <div class="p-field-checkbox">
                    <p-checkbox (onChange)="clickCheckBox('antecedentesEnfermedadNo', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.antecedentesEnfermedadSi.value && !f.antecedentesEnfermedadNo.value}"
                      formControlName="antecedentesEnfermedadNo" inputId="antecedentesEnfermedadNo" label="No"
                      name="antecedentesEnfermedadNo" [ngModel]="examen.antecedentesEnfermedad === false"
                      [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <div class="p-col-12 p-md-12">
                <app-invalid-from-message *ngIf="submitted && !f.antecedentesEnfermedadSi.value  &&
                  !f.antecedentesEnfermedadNo.value">
                </app-invalid-from-message>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-12 p-md-12">
                <app-fiel-title label="Descripción: "></app-fiel-title>
              </div>
              <div *ngIf="configForm.findField('observacionesAntEnfermedad')" class="p-col-12 p-md-6 print_row-full">
                <p [ngClass]="{'print_show-on-print': f.observacionesAntEnfermedad.value.length > 0 && f.antecedentesEnfermedadSi.value,
                              'print_hide-on-print': f.observacionesAntEnfermedad.value.length < 1}"
                  class="print_hidden-area-before-print print_row-full p-field-word-break">
                  {{f.observacionesAntEnfermedad.value}}
                </p>
                <textarea class="print_hide-on-print"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAntEnfermedad.invalid}" cols="30"
                  formControlName="observacionesAntEnfermedad" id="result" maxlength="1000" name="resul" pInputTextarea
                  rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                </textarea>
                <small style="text-align: end;">
                  {{ f.observacionesAntEnfermedad.value.length }}/1000
                </small>
                <app-invalid-from-message *ngIf="submitted && f.observacionesAntEnfermedad.errors?.required">
                </app-invalid-from-message>
                <app-invalid-from-message *ngIf="f.observacionesAntEnfermedad.errors?.maxlength"
                  message="Solo se permiten {{ f.observacionesAntEnfermedad.errors.maxlength.requiredLength  }} caracteres">
                </app-invalid-from-message>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Antecedentes Trastornos Congenitos ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Antecedentes de trastornos congénitos: " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('antecedentesTrastornosCongenitosSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesTrastornosCongenitosSi', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesTrastornosCongenitosSi.value && !f.antecedentesTrastornosCongenitosNo.value}"
                    formControlName="antecedentesTrastornosCongenitosSi" inputId="antecedentesTrastornosCongenitosSi"
                    label="Si" name="antecedentesTrastornosCongenitosSi"
                    [ngModel]="examen.antecedentesTrastornosCongenitos" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('antecedentesTrastornosCongenitosNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesTrastornosCongenitosNo', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesTrastornosCongenitosSi.value && !f.antecedentesTrastornosCongenitosNo.value}"
                    formControlName="antecedentesTrastornosCongenitosNo" inputId="antecedentesTrastornosCongenitosNo"
                    label="No" name="antecedentesTrastornosCongenitosNo"
                    [ngModel]="examen.antecedentesTrastornosCongenitos === false"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.antecedentesTrastornosCongenitosSi.value  &&
                !f.antecedentesTrastornosCongenitosNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('observacionesAntTrastornosCongenitos')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.observacionesAntTrastornosCongenitos.value.length > 0 && f.antecedentesTrastornosCongenitosSi.value,
                'print_hide-on-print': f.observacionesAntTrastornosCongenitos.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesAntTrastornosCongenitos.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAntTrastornosCongenitos.invalid}"
                cols="30" formControlName="observacionesAntTrastornosCongenitos" id="result" maxlength="1000"
                name="resul" pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesAntTrastornosCongenitos.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesAntTrastornosCongenitos.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesAntTrastornosCongenitos.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesAntTrastornosCongenitos.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Antecedentes Accidentes Trabajo ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Antecedentes por accidentes de trabajo: " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('antecedentesEnfermedadesProfesionalesSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesEnfermedadesProfesionalesSi', $event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesEnfermedadesProfesionalesSi.value && !f.antecedentesEnfermedadesProfesionalesNo.value}"
                    binary="true" formControlName="antecedentesEnfermedadesProfesionalesSi"
                    inputId="antecedentesEnfermedadesProfesionalesSi" label="Si"
                    name="antecedentesEnfermedadesProfesionalesSi"
                    [ngModel]="examen.antecedentesEnfermedadesProfesionales" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('antecedentesEnfermedadesProfesionalesNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesEnfermedadesProfesionalesNo', $event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesEnfermedadesProfesionalesSi.value && !f.antecedentesEnfermedadesProfesionalesNo.value}"
                    binary="true" formControlName="antecedentesEnfermedadesProfesionalesNo"
                    inputId="antecedentesEnfermedadesProfesionalesNo" label="No"
                    name="antecedentesEnfermedadesProfesionalesNo"
                    [ngModel]="examen.antecedentesEnfermedadesProfesionales === false"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.antecedentesEnfermedadesProfesionalesSi.value  &&
                !f.antecedentesEnfermedadesProfesionalesNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('observacionesAntEnfermedadesProfesionales')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.observacionesAntEnfermedadesProfesionales.value.length > 0 && f.antecedentesEnfermedadesProfesionalesSi.value,
                'print_hide-on-print': f.observacionesAntEnfermedadesProfesionales.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesAntEnfermedadesProfesionales.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAntEnfermedadesProfesionales.invalid}"
                cols="30" formControlName="observacionesAntEnfermedadesProfesionales" id="result" maxlength="1000"
                name="resul" pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesAntEnfermedadesProfesionales.value.length }}/1000
              </small>
              <app-invalid-from-message
                *ngIf="submitted && f.observacionesAntEnfermedadesProfesionales.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesAntEnfermedadesProfesionales.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesAntEnfermedadesProfesionales.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Antecedentes trabajos anteriores ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Antecedentes de trabajos anteriores con déficit de iluminación: "
                required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('antecedentesTrabajosAnterioresSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesTrabajosAnterioresSi', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesTrabajosAnterioresSi.value && !f.antecedentesTrabajosAnterioresNo.value}"
                    formControlName="antecedentesTrabajosAnterioresSi" inputId="antecedentesTrabajosAnterioresSi"
                    label="Si" name="antecedentesTrabajosAnterioresSi" [ngModel]="examen.antecedentesTrabajosAnteriores"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('antecedentesTrabajosAnterioresNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('antecedentesTrabajosAnterioresNo', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted &&
                    !f.antecedentesTrabajosAnterioresSi.value && !f.antecedentesTrabajosAnterioresNo.value}"
                    formControlName="antecedentesTrabajosAnterioresNo" inputId="antecedentesTrabajosAnterioresNo"
                    label="No" name="antecedentesTrabajosAnterioresNo"
                    [ngModel]="examen.antecedentesTrabajosAnteriores === false"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.antecedentesTrabajosAnterioresSi.value  &&
                !f.antecedentesTrabajosAnterioresNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('observacionesAntTrabajosAnteriores')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.observacionesAntTrabajosAnteriores.value.length > 0 && f.antecedentesTrabajosAnterioresSi.value,
                'print_hide-on-print': f.observacionesAntTrabajosAnteriores.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesAntTrabajosAnteriores.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAntTrabajosAnteriores.invalid}" cols="30"
                formControlName="observacionesAntTrabajosAnteriores" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesAntTrabajosAnteriores.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesAntTrabajosAnteriores.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesAntTrabajosAnteriores.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesAntTrabajosAnteriores.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
      </div>

      <!-- ----------------------------------4.Estudio Clínico ---------------------------------- -->
      <div *ngIf="configForm.findSection('Estudio Clínico')">
        <div class="print_dont_break">
          <div class="p-grid p-mt-2">
            <span class="p-title-seccion">
              {{ configForm.findNumberSection("Estudio Clínico") }}.Estudio Clínico
            </span>
          </div>
          <p-divider></p-divider>
          <!-- ----------------------------------Cefaleas ---------------------------------- -->
          <div class="p-col-12 p-md-12">
            <div class="p-grid">
              <div class="p-col-12 p-md-4">
                <app-fiel-title label="Cefaleas: " required="true"></app-fiel-title>
              </div>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div *ngIf="configForm.findField('cefaleasSi')" class="p-col-12 p-md-6">
                  <div class="p-field-checkbox ">
                    <p-checkbox (onChange)="clickCheckBox('cefaleasSi', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.cefaleasSi.value && !f.cefaleasNo.value}"
                      formControlName="cefaleasSi" inputId="cefaleasSi" label="Si" name="cefaleasSi"
                      [ngModel]="examen.cefaleas" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div *ngIf="configForm.findField('cefaleasNo')" class="p-col-12 p-md-6">
                  <div class="p-field-checkbox">
                    <p-checkbox (onChange)="clickCheckBox('cefaleasNo', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.cefaleasSi.value && !f.cefaleasNo.value}"
                      formControlName="cefaleasNo" inputId="cefaleasNo" label="No" name="cefaleasNo"
                      [ngModel]="examen.cefaleas === false" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <div class="p-col-12 p-md-12">
                <app-invalid-from-message *ngIf="submitted && !f.cefaleasSi.value  && !f.cefaleasNo.value">
                </app-invalid-from-message>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-12 p-md-12">
                <app-fiel-title label="Descripción: "></app-fiel-title>
              </div>
              <div *ngIf="configForm.findField('descripcionCefaleas')" class="p-col-12 p-md-6 print_row-full">
                <p [ngClass]="{'print_show-on-print': f.descripcionCefaleas.value.length > 0 && f.cefaleasSi.value,
                  'print_hide-on-print': f.descripcionCefaleas.value.length < 1}"
                  class="print_hidden-area-before-print print_row-full p-field-word-break">
                  {{f.descripcionCefaleas.value}}
                </p>
                <textarea class="print_hide-on-print"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionCefaleas.invalid}" cols="30"
                  formControlName="descripcionCefaleas" id="result" maxlength="1000" name="resul" pInputTextarea rows="5"
                  [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                </textarea>
                <small style="text-align: end;">
                  {{ f.descripcionCefaleas.value.length }}/1000
                </small>
                <app-invalid-from-message *ngIf="submitted && f.descripcionCefaleas.errors?.required">
                </app-invalid-from-message>
                <app-invalid-from-message *ngIf="f.descripcionCefaleas.errors?.maxlength"
                  message="Solo se permiten {{ f.descripcionCefaleas.errors.maxlength.requiredLength  }} caracteres">
                </app-invalid-from-message>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Visión doble ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Visión doble: " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('visionDobleSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('visionDobleSi', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.visionDobleSi.value && !f.visionDobleNo.value}"
                    formControlName="visionDobleSi" inputId="visionDobleSi" label="Si" name="visionDobleSi"
                    [ngModel]="examen.visionDoble" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('visionDobleNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('visionDobleNo', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.visionDobleSi.value && !f.visionDobleNo.value}"
                    formControlName="visionDobleNo" inputId="visionDobleNo" label="No" name="visionDobleNo"
                    [ngModel]="examen.visionDoble === false" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.visionDobleSi.value  && !f.visionDobleNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('descripcionVisionDoble')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.descripcionVisionDoble.value.length > 0 && f.visionDobleSi.value,
                'print_hide-on-print': f.descripcionVisionDoble.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionVisionDoble.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionVisionDoble.invalid}" cols="30"
                formControlName="descripcionVisionDoble" id="result" maxlength="1000" name="resul" pInputTextarea
                rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionVisionDoble.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionVisionDoble.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionVisionDoble.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionVisionDoble.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Mareos / Vértigo ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Mareos / Vértigo: " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('mareosSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('mareosSi', $event)" binary="true" formControlName="mareosSi"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.mareosSi.value && !f.mareosNo.value}"
                    inputId="mareosSi" label="Si" name="mareosSi" [ngModel]="examen.mareos"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('mareosNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('mareosNo', $event)" binary="true" formControlName="mareosNo"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.mareosSi.value && !f.mareosNo.value}"
                    inputId="mareosNo" label="No" name="mareosNo" [ngModel]="examen.mareos === false"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.mareosSi.value  && !f.mareosNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('descripcionMareos')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.descripcionMareos.value.length > 0 && f.mareosSi.value,
                'print_hide-on-print': f.descripcionMareos.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionMareos.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionMareos.invalid}" cols="30"
                formControlName="descripcionMareos" id="result" maxlength="1000" name="resul" pInputTextarea rows="5"
                [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">{{ f.descripcionMareos.value.length }}
                /1000</small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionMareos.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionMareos.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionMareos.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Conjuntivitis ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Conjuntivitis: " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('conjuntivitisSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('conjuntivitisSi', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.conjuntivitisSi.value && !f.conjuntivitisNo.value}"
                    formControlName="conjuntivitisSi" inputId="conjuntivitisSi" label="Si" name="conjuntivitisSi"
                    [ngModel]="examen.conjuntivitis" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('conjuntivitisNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('conjuntivitisNo', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.conjuntivitisSi.value && !f.conjuntivitisNo.value}"
                    formControlName="conjuntivitisNo" inputId="conjuntivitisNo" label="No" name="conjuntivitisNo"
                    [ngModel]="examen.conjuntivitis === false" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.conjuntivitisSi.value  && !f.conjuntivitisNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('descripcionConjuntivitis')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.descripcionConjuntivitis.value.length > 0 && f.conjuntivitisSi.value,
                'print_hide-on-print': f.descripcionConjuntivitis.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionConjuntivitis.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionConjuntivitis.invalid}" cols="30"
                formControlName="descripcionConjuntivitis" id="result" maxlength="1000" name="resul" pInputTextarea
                rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionConjuntivitis.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionConjuntivitis.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionConjuntivitis.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionConjuntivitis.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
        <!-- ----------------------------------Visión borrosa ---------------------------------- -->
        <div class="p-col-12 p-md-12">
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-4 title">
              <app-fiel-title label="Visión borrosa " required="true"></app-fiel-title>
            </div>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div *ngIf="configForm.findField('visionBorrosaSi')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox ">
                  <p-checkbox (onChange)="clickCheckBox('visionBorrosaSi', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.visionBorrosaSi.value && !f.visionBorrosaNo.value}"
                    formControlName="visionBorrosaSi" inputId="visionBorrosaSi" label="Si" name="visionBorrosaSi"
                    [ngModel]="examen.visionBorrosa" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <div *ngIf="configForm.findField('visionBorrosaNo')" class="p-col-12 p-md-6">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('visionBorrosaNo', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.visionBorrosaSi.value && !f.visionBorrosaNo.value}"
                    formControlName="visionBorrosaNo" inputId="visionBorrosaNo" label="No" name="visionBorrosaNo"
                    [ngModel]="examen.visionBorrosa === false" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12">
              <app-invalid-from-message *ngIf="submitted && !f.visionBorrosaSi.value  && !f.visionBorrosaNo.value">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break">
            <div class="p-col-12 p-md-12">
              <app-fiel-title label="Descripción: "></app-fiel-title>
            </div>
            <div *ngIf="configForm.findField('descripcionVisionBorrosa')" class="p-col-12 p-md-6 print_row-full">
              <p [ngClass]="{'print_show-on-print': f.descripcionVisionBorrosa.value.length > 0 && f.visionBorrosaSi.value,
                'print_hide-on-print': f.descripcionVisionBorrosa.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionVisionBorrosa.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionVisionBorrosa.invalid}" cols="30"
                formControlName="descripcionVisionBorrosa" id="result" maxlength="1000" name="resul" pInputTextarea
                rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionVisionBorrosa.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionVisionBorrosa.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionVisionBorrosa.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionVisionBorrosa.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
      </div>

      <!-- ------------------------------------5.Estudio Ocular---------------------------- -->
      <div *ngIf="configForm.findSection('Estudio Ocular')">
        <div class="print_dont_break">
          <div class="p-grid p-mt-2">
            <span class="p-title-seccion">
              {{ configForm.findNumberSection("Estudio Ocular") }}.Estudio Ocular
            </span>
          </div>
          <p-divider></p-divider>
          <div class="p-grid">
            <div class="p-field p-col-12 p-md-4 print_row-fill-block p-field-without-border">
              <!-- ----------------------------------Ojos Centrados ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Ojos Centrados: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('ojosCentradosSi')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.ojosCentradosSi.value && !f.ojosCentradosNo.value}"
                        (onChange)="clickCheckBox('ojosCentradosSi', $event)" binary="true"
                        formControlName="ojosCentradosSi" inputId="ojosCentradosSi" label="Si" name="ojosCentradosSi"
                        [ngModel]="examen.ojosCentrados" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('ojosCentradosNo')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.ojosCentradosSi.value && !f.ojosCentradosNo.value}"
                        (onChange)="clickCheckBox('ojosCentradosNo', $event)" binary="true"
                        formControlName="ojosCentradosNo" inputId="ojosCentradosNo" label="No" name="ojosCentradosNo"
                        [ngModel]="examen.ojosCentrados === false" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.ojosCentradosSi.value  && !f.ojosCentradosNo.value">
                  </app-invalid-from-message>
                </div>
              </div>
              <!-- ----------------------------------Conjuntivas ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Conjuntivas: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('conjuntivasNormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.conjuntivasNormal.value && !f.conjuntivasAnormal.value}"
                        binary="true" formControlName="conjuntivasNormal"
                        (onChange)="clickCheckBox('conjuntivasNormal', $event)" inputId="conjuntivasNormal" label="Normal"
                        name="conjuntivasNormal" [ngModel]="examen.conjuntivasNormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('conjuntivasAnormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.conjuntivasNormal.value && !f.conjuntivasAnormal.value}"
                        binary="true" formControlName="conjuntivasAnormal"
                        (onChange)="clickCheckBox('conjuntivasAnormal', $event)" inputId="conjuntivasAnormal"
                        label="Anormal" name="conjuntivasAnormal" [ngModel]="examen.conjuntivasAnormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message
                    *ngIf="submitted && !f.conjuntivasNormal.value  && !f.conjuntivasAnormal.value">
                  </app-invalid-from-message>
                </div>
              </div>
              <!-- ----------------------------------Motilidad Ocular ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Motilidad Ocular: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('motilidadNormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox [ngClass]="{'ng-invalid ng-dirty': submitted && !f.motilidadNormal.value &&
                        !f.motilidadAnormal.value}" (onChange)="clickCheckBox('motilidadNormal', $event)" binary="true"
                        formControlName="motilidadNormal" inputId="motilidadNormal" label="Normal" name="motilidadNormal"
                        [ngModel]="examen.motilidadNormal" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('motilidadAnormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox [ngClass]="{'ng-invalid ng-dirty': submitted && !f.motilidadNormal.value &&
                        !f.motilidadAnormal.value}" (onChange)="clickCheckBox('motilidadAnormal', $event)" binary="true"
                        formControlName="motilidadAnormal" inputId="motilidadAnormal" label="Anormal"
                        name="motilidadAnormal" [ngModel]="examen.motilidadAnormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.motilidadNormal.value  && !f.motilidadAnormal.value">
                  </app-invalid-from-message>
                </div>
              </div>
              <!-- ----------------------------------Nistagmus ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Nistagmus: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('nistagmusAnormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox [ngClass]="{'ng-invalid ng-dirty': submitted && !f.nistagmusNormal.value &&
                        !f.nistagmusAnormal.value}" (onChange)="clickCheckBox('nistagmusAnormal', $event)" binary="true"
                        formControlName="nistagmusAnormal" inputId="nistagmusAnormal" label="Presente"
                        name="nistagmusAnormal" [ngModel]="examen.nistagmusAnormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('nistagmusNormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox [ngClass]="{'ng-invalid ng-dirty': submitted && !f.nistagmusNormal.value &&
                        !f.nistagmusAnormal.value}" (onChange)="clickCheckBox('nistagmusNormal', $event)" binary="true"
                        formControlName="nistagmusNormal" inputId="nistagmusNormal" label="Ausente" name="nistagmusNormal"
                        [ngModel]="examen.nistagmusNormal" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.nistagmusNormal.value  && !f.nistagmusAnormal.value">
                  </app-invalid-from-message>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-4 print_row-fill-block p-field-without-border">
              <!-- ----------------------------------Pupilas ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Pupilas: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('pupilasNormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.pupilasNormal.value && !f.pupilasAnormal.value}"
                        (onChange)="clickCheckBox('pupilasNormal', $event)" binary="true" formControlName="pupilasNormal"
                        inputId="pupilasNormal" label="Normal" name="pupilasNormal" [ngModel]="examen.pupilasNormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('pupilasAnormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.pupilasNormal.value && !f.pupilasAnormal.value}"
                        (onChange)="clickCheckBox('pupilasAnormal', $event)" binary="true"
                        formControlName="pupilasAnormal" inputId="pupilasAnormal" label="Anormal" name="pupilasAnormal"
                        [ngModel]="examen.pupilasAnormal" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.pupilasNormal.value  && !f.pupilasAnormal.value">
                  </app-invalid-from-message>
                </div>
              </div>
              <!-- ----------------------------------Corneas ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Córneas: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('corneasNormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.corneasNormal.value && !f.corneasAnormal.value}"
                        (onChange)="clickCheckBox('corneasNormal', $event)" binary="true" formControlName="corneasNormal"
                        inputId="corneasNormal" label="Normal" name="corneasNormal" [ngModel]="examen.corneasNormal"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('corneasAnormal')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.corneasNormal.value && !f.corneasAnormal.value}"
                        (onChange)="clickCheckBox('corneasAnormal', $event)" binary="true"
                        formControlName="corneasAnormal" inputId="corneasAnormal" label="Anormal" name="corneasAnormal"
                        [ngModel]="examen.corneasAnormal" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.corneasNormal.value  && !f.corneasAnormal.value">
                  </app-invalid-from-message>
                </div>
              </div>
              <!-- ----------------------------------Fotosensibilidad ---------------------------------- -->
              <div class="p-grid print_row-content-inline">
                <div class="p-col-12 p-md-12">
                  <app-fiel-title label="Fotosensibilidad: " required="true"></app-fiel-title>
                </div>
                <div class="prueba">
                  <div *ngIf="configForm.findField('fotosensibilidadSi')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.fotosensibilidadSi.value && !f.fotosensibilidadNo.value}"
                        (onChange)="clickCheckBox('fotosensibilidadSi', $event)" binary="true" formControlName="fotosensibilidadSi"
                        inputId="fotosensibilidadSi" label="Si" name="fotosensibilidadSi" [ngModel]="examen.fotosensibilidad"
                        [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                  <div *ngIf="configForm.findField('fotosensibilidadNo')" class="p-col-12 p-md-6">
                    <div class="p-field-checkbox">
                      <p-checkbox
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !f.fotosensibilidadSi.value && !f.fotosensibilidadNo.value}"
                        (onChange)="clickCheckBox('fotosensibilidadNo', $event)" binary="true"
                        formControlName="fotosensibilidadNo" inputId="fotosensibilidadNo" label="No" name="fotosensibilidadNo"
                        [ngModel]="examen.fotosensibilidad === false" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="p-col-12 p-md-12">
                  <app-invalid-from-message *ngIf="submitted && !f.fotosensibilidadSi.value  && !f.fotosensibilidadNo.value">
                  </app-invalid-from-message>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ------------------------------------6.Agudeza Visual---------------------------- -->
      <div *ngIf="configForm.findSection('Agudeza Visual')">
        <div class="print_dont_break">
          <div class="p-grid p-mt-2">
            <span class="p-title-seccion">
              {{ configForm.findNumberSection("Agudeza Visual") }}.Agudeza Visual
            </span>
          </div>
          <p-divider></p-divider>
          <div class="p-grid">
            <div class="p-col-12 p-md-4 print_row-full">
              <!-- ------------------------------------ojo izq sin correccion---------------------------- -->
              <div *ngIf="configForm.findField('ojoIzquierdoSinCorreccion')" class="p-field p-col-12 p-md-8">
                <app-fiel-title label="Ojo Izquierdo sin corrección: "></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.ojoIzquierdoSinCorreccion.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoIzquierdoSinCorreccion.invalid}"
                  formControlName="ojoIzquierdoSinCorreccion" id="ojoIzquierdoSinCorreccion"
                  name="ojoIzquierdoSinCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.ojoIzquierdoSinCorreccion.errors?.required"></app-invalid-from-message>
                <app-invalid-from-message *ngIf="submitted && (f.ojoIzquierdoSinCorreccion.errors?.min || f.ojoIzquierdoSinCorreccion.errors?.max)"
                  message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
              </div>
              <!-- ------------------------------------ojo der sin correccion---------------------------- -->
              <div *ngIf="configForm.findField('ojoDerechoSinCorreccion')" class="p-field p-col-12 p-md-8">
                <app-fiel-title label="Ojo Derecho sin corrección: "></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.ojoDerechoSinCorreccion.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoDerechoSinCorreccion.invalid}"
                  formControlName="ojoDerechoSinCorreccion" id="ojoDerechoSinCorreccion"
                  name="ojoDerechoSinCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.ojoDerechoSinCorreccion.errors?.required"></app-invalid-from-message>
                <app-invalid-from-message *ngIf="submitted && (f.ojoDerechoSinCorreccion.errors?.min || f.ojoDerechoSinCorreccion.errors?.max)"
                  message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
              </div>
            </div>
            <div class="p-col-12 p-md-4 print_row-full">
              <!-- ------------------------------------ojo izq con correccion---------------------------- -->
              <div *ngIf="configForm.findField('ojoIzquierdoConCorreccion')" class="p-field p-col-12 p-md-8">
                <app-fiel-title label=" Ojo Izquierdo con corrección: "></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.ojoIzquierdoConCorreccion.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoIzquierdoConCorreccion.invalid}"
                  formControlName="ojoIzquierdoConCorreccion" id="ojoIzquierdoConCorreccion"
                  name="ojoIzquierdoConCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.ojoIzquierdoConCorreccion.errors?.required"></app-invalid-from-message>
                <app-invalid-from-message *ngIf="submitted && (f.ojoIzquierdoConCorreccion.errors?.min || f.ojoIzquierdoConCorreccion.errors?.max)"
                  message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
              </div>
              <!-- ------------------------------------ojo der con correccion---------------------------- -->
              <div *ngIf="configForm.findField('ojoDerechoConCorreccion')" class="p-field p-col-12 p-md-8">
                <app-fiel-title label="Ojo Derecho con corrección: "></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.ojoDerechoConCorreccion.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoDerechoConCorreccion.invalid}"
                  formControlName="ojoDerechoConCorreccion" id="ojoDerechoConCorreccion"
                  name="ojoDerechoConCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.ojoDerechoConCorreccion.errors?.required"></app-invalid-from-message>
                <app-invalid-from-message *ngIf="submitted && (f.ojoDerechoConCorreccion.errors?.min || f.ojoDerechoConCorreccion.errors?.max)"
                  message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Seccion Dictamen medico-->
      <div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
        </label>
        <p-divider></p-divider>

        <div class="p-grid">
          <!--Campo Tipo Dictamen-->
          <div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

              <div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

                <p-radioButton name="codigoDictamen" [value]="item.codigo" formControlName="codigoDictamen"
                  label="{{ item.descripcion }}"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
                </p-radioButton>

              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Especialidades-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Especialidad" required="true"></app-fiel-title>
            <p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
              [options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
              optionLabel="descripcion" optionValue="codigo" [showClear]="true"
              [disabled]="examen?.modoVista === 'ver'">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Médico-->
          <div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Médico" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}" alfanumericoDirective
              formControlName="medicoNombre" id="medico" name="medico" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Matricula-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Matrícula" required="true"></app-fiel-title>
            <!-- Modificar para validar el formato de la matricula -->
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.matricula.invalid}" numberDirective
              formControlName="matricula" id="matricula" name="matricula" maxlength="18" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.matricula.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
					</div>
          <div class="p-field p-col-12 p-md-12">
            <app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
          </div>
				</div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.examen?.id"
          [isRequire]="configForm.isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
          [attachedFilesFromBackend]="this.examen?.attachments" [viewMode]="this.examen?.modoVista"
          [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>
      <!-- ------------------------------------------------footer botones------------------------------------------------ -->
      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
          <ng-container *ngIf="examen?.modoVista === 'ver'">
            <button pButton pRipple type="button" label="Volver" class="p-button-text" (click)="goBack()"></button>
          </ng-container>

          <ng-container *ngIf="examen?.modoVista !== 'ver'">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose"
              [disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
            </p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
          </ng-container>
        </div>
      </div>

      <app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.medicoEspecialidad.value"
                        [medicoMatricula]="f.matricula?.value">
      </app-print-footer>

    </div>
  </form>

  <p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC" styleClass="p-dialog-custom">
    <p-footer>
      <button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton type="button"></button>
      <button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
    </p-footer>

  </p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma" (closeModal)="closeModalFirma()"></app-topaz>
</section>
